// extracted by mini-css-extract-plugin
module.exports = {"root":"button-group_root__hiUkX","direction-horizontal":"button-group_direction-horizontal__0n9RU","direction-vertical":"button-group_direction-vertical__8cdvs"};